import { ACH, ACH_METHOD, AFFIRM, AFFIRM_METHOD, APPLE_PAY_METHOD, BACS, BACS_METHOD, CARD, CARD_METHOD, GOOGLE_PAY_METHOD, KLARNA, KLARNA_METHOD, PADS, PADS_METHOD, SEPA, SEPA_METHOD } from 'payments-checkout-lib/constants/PaymentElement';
const isPaymentAmountValid = (paymentAmount, method, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) => (!minimumAmountForPaymentMethod || minimumAmountForPaymentMethod[method] === undefined || paymentAmount >= minimumAmountForPaymentMethod[method]) && paymentAmount <= maximumAmountForPaymentMethod[method];
export const getValidPaymentMethods = (paymentMethods, paymentAmount, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) => paymentMethods.map(paymentMethod => {
  switch (paymentMethod) {
    case isPaymentAmountValid(paymentAmount, CARD, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && CARD:
      return CARD_METHOD;
    case isPaymentAmountValid(paymentAmount, ACH, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && ACH:
      return ACH_METHOD;
    case isPaymentAmountValid(paymentAmount, BACS, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && BACS:
      return BACS_METHOD;
    case isPaymentAmountValid(paymentAmount, PADS, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && PADS:
      return PADS_METHOD;
    case isPaymentAmountValid(paymentAmount, SEPA, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && SEPA:
      return SEPA_METHOD;
    case isPaymentAmountValid(paymentAmount, AFFIRM, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && AFFIRM:
      return AFFIRM_METHOD;
    case isPaymentAmountValid(paymentAmount, KLARNA, maximumAmountForPaymentMethod, minimumAmountForPaymentMethod) && KLARNA:
      return KLARNA_METHOD;
    default:
      return null;
  }
}).filter(paymentMethod => typeof paymentMethod === 'string');
export const isCardOrWallet = paymentMethod => {
  return paymentMethod === CARD_METHOD || paymentMethod === GOOGLE_PAY_METHOD || paymentMethod === APPLE_PAY_METHOD;
};
export const isBnpl = paymentMethod => {
  return paymentMethod === KLARNA || paymentMethod === AFFIRM;
};
export const isACHorSEPA = paymentMethod => {
  return paymentMethod === ACH || paymentMethod === SEPA;
};
export const isACHorPADS = paymentMethod => {
  return paymentMethod === ACH || paymentMethod === PADS;
};
export const isCardorACH = paymentMethod => {
  return paymentMethod === CARD || paymentMethod === ACH;
};
export const stripeToHSPaymentMethod = stripePaymentMethod => {
  switch (stripePaymentMethod) {
    case CARD_METHOD:
      return CARD;
    case ACH_METHOD:
      return ACH;
    case BACS_METHOD:
      return BACS;
    case PADS_METHOD:
      return PADS;
    case SEPA_METHOD:
      return SEPA;
    case KLARNA_METHOD:
      return KLARNA;
    case AFFIRM_METHOD:
      return AFFIRM;
    // Apple/Google Pay is considered CARD as well
    default:
      return CARD;
  }
};
export const hsToStripePaymentMethod = paymentMethod => {
  switch (paymentMethod) {
    case CARD:
      return CARD_METHOD;
    case ACH:
      return ACH_METHOD;
    case BACS:
      return BACS_METHOD;
    case PADS:
      return PADS_METHOD;
    case SEPA:
      return SEPA_METHOD;
    case KLARNA:
      return KLARNA_METHOD;
    case AFFIRM:
      return AFFIRM_METHOD;
    // Apple/Google Pay is considered CARD as well
    default:
      return CARD_METHOD;
  }
};